import { notification } from "antd";
import { useCoordinator } from "@/shared/lib/hooks";
import { NOTIFICATION_MESSAGES } from "@/shared/utils";
import { useReturnTitleJournal } from "../mutate-hooks/use-return-title-journal";

interface IUseReturnTitleModal {
  setIsLoading?: (isLoading: boolean) => void;
  handleClear: () => void;
}

export const useReturnTitleModal = ({
  setIsLoading,
  handleClear,
}: IUseReturnTitleModal) => {
  const { titleId } = useCoordinator();
  const { mutate: returnTitle } = useReturnTitleJournal({ titleId });

  const handleResend = async () => {
    setIsLoading?.(true);
    returnTitle({
      onSuccess: () => {
        notification.success({
          message: NOTIFICATION_MESSAGES.SUCCESS, // "Успешно"
          description: NOTIFICATION_MESSAGES.TITLE_RETURNED_TO_WORK_DESC, // "Титульный лист возвращен в работу"
          placement: "topRight",
        });
        handleClear();
      },
      onError: () => {
        notification.success({
          message: NOTIFICATION_MESSAGES.SUCCESS, // "Успешно"
          description: NOTIFICATION_MESSAGES.TITLE_RETURNED_TO_WORK_DESC, // "Титульный лист возвращен в работу"
          placement: "topRight",
        });
        handleClear();
      },
      onSettled: () => {
        setIsLoading?.(false);
      },
    });
  };

  return { handleResend };
};
